import React from 'react';
import MarketHoursTable from './MarketHoursTable';

const MarketHoursGainers = ({ data }) => {
    return (
        <MarketHoursTable
            type="gainers"
            titleTop="Top Gainers:"
            title="Top Stocks of the Day"
            info="The 'Market Top Gainers' screener lists the stocks with the highest percentage gains in a single day."
            data={data}
        />
    );
};

export default MarketHoursGainers;